package org.wordsapp.ui.component

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun CompletionView(
    totalWords: Int,
    onNextRound: () -> Unit,
    onViewStatistics: () -> Unit,
    modifier: Modifier = Modifier,
) {
    OnEnterKey(onPressed = onNextRound)

    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(32.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Text(
            text = "🎉",
            fontSize = 64.sp,
        )
        Spacer(Modifier.height(16.dp))
        Text(
            text = "Round Complete!",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.primary,
        )
        Spacer(Modifier.height(8.dp))
        Text(
            text = "You practiced $totalWords words",
            style = MaterialTheme.typography.bodyLarge,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(32.dp))
        PrimaryButton(
            text = "Next Round",
            onClick = onNextRound,
        )
        Spacer(Modifier.height(12.dp))
        SecondaryButton(
            text = "View Statistics",
            onClick = onViewStatistics,
        )
    }
}
